import { useState, useEffect } from 'react';

function NeurudaLogo({ scrolled = false }) {
  return (
    <div className={`rounded-lg transition-all duration-300 ${
      scrolled
        ? 'bg-transparent px-0 py-0'
        : 'bg-white px-3 py-1.5 shadow-md'
    }`}>
      <img
        src={`${process.env.PUBLIC_URL}/neruda_logo_hq.webp`}
        alt="Neruda Tours & Safaris"
        width="150"
        height="50"
        loading="eager"
        fetchPriority="high"
        decoding="async"
        className={`w-auto object-contain transition-all duration-300 ${
          scrolled ? 'h-10' : 'h-12'
        }`}
      />
    </div>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const links = [
    { label: 'Home',      id: 'hero'      },
    { label: 'Vehicles',  id: 'vehicles'  },
    { label: 'Zanzibar',  id: 'zanzibar'  },
    { label: 'Tanzania',  id: 'tanzania'  },
    { label: 'Contact',   id: 'contact'   },
  ];

  const textCls = scrolled ? 'text-brand-green' : 'text-white';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-2.5 focus:outline-none"
          aria-label="Neruda Tours & Safaris — Home"
        >
          <NeurudaLogo scrolled={scrolled} />
        </button>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-7">
          {links.map(({ label, id }) => (
            <button key={id} onClick={() => scrollTo(id)}
              className={`font-semibold text-sm transition-colors hover:text-brand-gold ${textCls}`}>
              {label}
            </button>
          ))}
        </div>

        {/* Mobile hamburger */}
        <button className="md:hidden p-2 -mr-2" onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
          <svg className={`w-6 h-6 ${textCls}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className={`md:hidden border-t ${scrolled ? 'bg-white border-gray-100' : 'bg-brand-green border-white/10'}`}>
          {links.map(({ label, id }) => (
            <button key={id} onClick={() => scrollTo(id)}
              className={`block w-full text-left px-6 py-3 font-semibold text-sm ${
                scrolled ? 'text-brand-green hover:bg-brand-bg' : 'text-white hover:bg-white/10'
              }`}>
              {label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
